import { currentHomeIdState } from '@/state/home.state';
import { RoomDao } from '@rock/db-admin';
import { shallowEqual } from '@rock/util';
import { atom } from 'jotai';
import { keyBy } from 'lodash';

const dao = new RoomDao();

export const roomsState = dao.roomsAtom(currentHomeIdState);

export const roomsByIdState = atom(async (get) => {
    const rooms = await get(roomsState);
    return keyBy(rooms, 'id');
}, shallowEqual);
